<script setup>
import UserTimelineHeading from "~/components/timeline/UserTimelineHeading.vue";
import UserTimelineLayoutItem from "~/components/timeline/UserTimelineLayoutItem.vue";
import {ref} from "vue";

defineProps({
  item: {
    type: Object,
    required: true
  }
})

const current = ref(0) // Optional: for tracking index
</script>

<template>
  <div class="carousel-item-layout" style="overflow: visible;">
    <user-timeline-heading
        :title="item.layoutData.title"
        :subtitle="item.layoutData.subTitle"
    />

    <v-window
        v-model="current"
        class="d-relative"
        :show-arrows="true"
        :center-active="true"
    >
      <template #prev="slot">

      </template>
      <template #next="slot">

      </template>
      <v-window-item
          v-for="slide in item.layoutData.items"
          :key="slide.id"
      >
        <div class="timeline-item">
          <user-timeline-layout-item :item="slide"/>
        </div>
      </v-window-item>
    </v-window>
    <v-btn :icon="true" v-if="current < item.layoutData.items.length-1" color="primary" class="nav-btn next"  @click="current++">
        <v-icon size="18" >mdi-chevron-right</v-icon>
    </v-btn>
    <v-btn :icon="true" v-if="current > 0" class="nav-btn prev" color="primary"  @click="current--">
        <v-icon size="18" >mdi-chevron-left</v-icon>
    </v-btn>
    <div class="d-flex justify-center">
      <v-slide-group
          v-model="current"
          :show-arrows="false"
          :center-active="true"
      >
        <v-slide-group-item v-for="(slide, index) in item.layoutData.items" :value="index">
          <v-icon @click="current = index" icon="mdi-circle" size="6" class="pa-3"
                  :color="current === index ? 'primary' : 'textSubtle'"/>
        </v-slide-group-item>
      </v-slide-group>
    </div>
  </div>
</template>

<style scoped lang="scss">
.nav-btn {
  cursor: pointer;
  position: absolute;
  top: 50%;
  text-align: center;
  height: 30px;
  width: 30px;
  border-radius: 15px;
  z-index: 1000;
  padding: 0;
  &.prev {
    left: -15px;
  }
  &.next {
    right: -15px;
  }
}
</style>
